import { ThreeDsStatus } from '@mc-alberta/types';
/**
 * Returns meta browser information for authenticating 3DS.
 */
export default function getThreeDsBrowserData() {
    return {
        threeDSCompInd: ThreeDsStatus.Unknown,
        acceptHeader: 'application/json, text/plain, */*',
        colorDepth: window.screen.colorDepth.toString(),
        javaEnabled: navigator.javaEnabled(),
        javascriptEnabled: true,
        language: navigator.language,
        screenHeight: window.screen.height.toString(),
        screenWidth: window.screen.width.toString(),
        tz: new Date().getTimezoneOffset().toString(),
        userAgent: navigator.userAgent
    };
}
//# sourceMappingURL=getThreeDsBrowserData.js.map